import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss';
import permission from './directives/permission'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.directive('permission', permission)

// 1. 捕获全局路由导航错误（可选，用于日志记录）
router.onError((error) => {
  // 可以在这里记录错误到监控系统，但不要抛出
  console.log('路由导航发生预期内错误:', error.message);
});

// 2. 【核心】覆写 router.push 和 router.replace 方法，全局捕获并忽略“重定向”错误
const originalPush = router.push;
const originalReplace = router.replace;

router.push = function push(location, onResolve, onReject) {
  // 如果用户提供了回调，则使用原始方法
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  // 否则，捕获错误并忽略特定的“重定向失败”
  return originalPush.call(this, location).catch(err => {
    // 判断错误是否是“重定向”类型的导航失败[citation:8]
    // Vue Router 3.x 使用 err.name 或 err.type 判断
    // 如果是 Vue Router 4，请使用 isNavigationFailure, NavigationFailureType
    if (err && err.name && err.name === 'NavigationDuplicated') {
      // 忽略重复导航错误
      return;
    }
    // 可以根据需要忽略重定向错误，例如检查错误信息
    if (err && err.message && err.message.includes('Redirected when going from')) {
      // 这正是我们要忽略的错误
      console.log('已安全拦截导航重定向错误，流程正常。');
      return;
    }
    // 对于其他错误，可以选择重新抛出
    // throw err;
  });
};

router.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name && err.name === 'NavigationDuplicated') {
      return;
    }
    if (err && err.message && err.message.includes('Redirected when going from')) {
      return;
    }
    // throw err;
  });
};
import { initRouterOnRefresh } from './router'

Vue.config.productionTip = false

// 在应用初始化时调用，处理页面刷新
initRouterOnRefresh().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
